module.exports = __webpack_public_path__ + "img/nigeria.0f7ee783.svg";